<template>
  <article>
    <div class="flex flex-1 fw jcb">
      <div class="flex flex-1 aic mt-20">
        <div class="form-item">用户昵称：</div>
        <div class="flex-1">{{detail.nickname}}({{detail.uid}})</div>
      </div>
      <div class="flex flex-1 aic mt-20">
        <div class="form-item">支付宝账号：</div>
        <div class="flex-1">{{detail.phone}}</div>
      </div>
      <div class="flex flex-1 aic mt-20">
        <div class="form-item">真实名字：</div>
        <div class="flex-1">{{detail.real_name}}</div>
      </div>
      <div class="flex flex-1 aic mt-20">
        <div class="form-item">注册时间：</div>
        <div class="flex-1" v-html="formatTimeStamp(detail.create_time, false)"></div>
      </div>
    </div>

    <div class="base mt-30">
      <div class="base__container">
        <div v-for="(item, index) in baseList" class="base__item" :key="index">
          <div class="base__name">{{item.name}}</div>
          <div class="base__value">{{item.value}}</div>
        </div>
      </div>
    </div>

    <div class="mt-20 fc-blue fs-16">广告记录</div>
    <el-table :data="userAdList" highlight-current-row v-loading="userAdLoading" class="mt-20">
      <el-table-column prop="" label="广告" width="">
        <template slot-scope="scope">
            <div>{{scope.row.title}}({{scope.row.adid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="ocount" label="订单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="payment" label="金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="commission" label="佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="invalid_num" label="丢单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="invalid_payment" label="丢单金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="apply_num" label="已通过订单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="apply_payment" label="已通过金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="apply_amount" label="已通过佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="exchange_amount" label="已打款金额" width="" align="center">
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleAdSizeChange" @current-change="handleAdCurrentChange" :page-size="userAdFilters.l" :page-sizes="[20, 50, 80, 100]" :total="userAdFilters.total" :current-page="userAdFilters.p" class="tac mt-36 pb-36">
    </el-pagination>

    <div class="mt-20 fc-blue fs-16">订单明细</div>
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="filter__name">广告：</div>
        <el-select class="filter__input" size="mini" v-model="checkFilters.adid">
          <el-option :label="item.title" :value="item.adid" v-for="(item, index) in adLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="checkFilters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <button class="blue-small-btn" @click="adOrderLists">搜索</button>
    </div>
    <el-table :data="orderList" highlight-current-row v-loading="checkloading" height="600" class="mt-20">
      <el-table-column prop="oid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="uid" label="用户" width="" align="center" sortable>
        <template slot-scope="scope">
          <div>{{scope.row.username}}({{scope.row.uid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="广告" width="">
        <template slot-scope="scope">
            <div>{{scope.row.title}}({{scope.row.adid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="orderid" label="订单ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="nickname" label="微信昵称" width="" align="center">
      </el-table-column>
      <el-table-column prop="purchase" label="购买类型" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.purchase == 0">需要返现</div>
          <div v-if="scope.row.purchase == 1">直接折扣</div>
          <div v-if="scope.row.purchase == 2">假单</div>
        </template>
      </el-table-column>
      <el-table-column prop="payment" label="金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="final_payment" label="实付金" width="" align="center">
      </el-table-column>
      <el-table-column prop="min_discount" label="底价折扣" width="" align="center">
        <template slot-scope="scope">
            <div>{{scope.row.min_discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="discount" label="项目折扣" width="" align="center">
        <template slot-scope="scope">
            <div>{{scope.row.discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="user_discount" label="用户折扣" width="" align="center">
        <template slot-scope="scope">
            <div>{{scope.row.user_discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="commission" label="佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="payment_img" label="报单截图" width="" align="center">
        <template slot-scope="scope">
          <div @click="previewURL(scope.row.oid, 0)">
            <img :src="scope.row.payment_img" style="width:60px;height:80px;" alt="" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="finish_img" label="完成截图" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.finish_img" @click="previewURL(scope.row.oid, 2)">
            <img :src="scope.row.finish_img" style="width:60px;height:80px;" alt="" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="" align="center" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.status == 6">拒绝</div>
          <div v-if="scope.row.status == 5">失效</div>
          <div v-if="scope.row.status == 4">已提现</div>
          <div v-if="scope.row.status == 3">返款中</div>
          <div v-if="scope.row.status == 2">完成订单</div>
          <div v-if="scope.row.status == 1">跟单中</div>
          <div v-if="scope.row.status == 0">报单</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleOrderSizeChange" @current-change="handleOrderCurrentChange" :page-size="checkFilters.l" :page-sizes="[20, 50, 80, 100]" :total="checkFilters.total" :current-page="checkFilters.p" class="tac mt-36 pb-36">
    </el-pagination>

    <el-dialog :visible.sync="previewDialog">
      <el-carousel type="card" :autoplay="false" height="500px">
        <el-carousel-item v-for="item in previewList" :key="item">
<!--          <img :src="item" height="400">-->
          <el-image
            style="height: 500px"
            :src="item"
            fit="contain"></el-image>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>

  </article>
</template>

<script>
import util from '../../../script/util'
import {adUserDetail, adUserAdLists, adLists, adOrderLists} from '../../../api/api'
export default {
  name: 'adUserDetail',
  data () {
    return {
      baseList: [
        { name: '接单广告数', ename: 'ad_number', value: 0 },
        { name: '总订单数', ename: 'ocount', value: 0 },
        { name: '总金额', ename: 'payment', value: 0 },
        { name: '总佣金', ename: 'commission', value: 0 },
        { name: '跟单中订单数', ename: 'running_ocount', value: 0 },
        { name: '跟单中金额', ename: 'running_payment', value: 0 },
        { name: '跟单中佣金', ename: 'running_commission', value: 0 },
        { name: '丢单数', ename: 'invalid_num', value: 0 },
        { name: '打款订单数', ename: 'exchange_order', value: 0 },
        { name: '打款金额', ename: 'exchange_payment', value: 0 },
        { name: '打款佣金', ename: 'exchange_amount', value: 0 }
      ],
      detail: {
        headimgurl: '',
        nickname: '',
        uid: ''
      },
      previewDialog: false, // 查看图片弹窗
      previewList: [], // 查看列表
      userAdList: [],
      userAdLoading: false,
      userAdFilters: {
        p: 1,
        l: 20,
        total: 0
      },
      orderList: [],
      checkloading: false,
      checkFilters: {
        p: 1,
        l: 20,
        total: 0,
        adid: '',
        status: ''
      },
      adLists: [],
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '报单',
          value: 0
        },
        {
          name: '跟单中',
          value: 1
        },
        {
          name: '完成订单',
          value: 2
        },
        {
          name: '提现中',
          value: 3
        },
        {
          name: '已提现',
          value: 4
        },
        {
          name: '丢单',
          value: 5
        }
      ]
    }
  },
  methods: {
    // 格式化时间
    formatTimeStamp (time, br = true) {
      return util.formatTimeStamp(time, br)
    },
    handleAdSizeChange (val) {
      this.userAdFilters.l = val
      this.adUserAdLists()
    },
    handleAdCurrentChange (val) {
      this.userAdFilters.p = val
      this.adUserAdLists()
    },
    previewURL (oid, status) {
      let images = []
      let initialViewIndex = 0
      this.orderList.forEach((item) => {
        if (status === 0) {
          if (item.payment_img !== '') {
            images.push(item.payment_img)
          }
        } else {
          if (item.finish_img !== '') {
            images.push(item.finish_img)
          }
        }
        if (item.oid === oid) {
          initialViewIndex = images.length - 1
        }
      })

      this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: initialViewIndex
        },
        images: images
      })
    },
    adUserDetail () {
      let params = {
        uid: this.detail.uid
      }
      this.loading = true
      adUserDetail(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.detail = data.d
          this.baseList.forEach((item) => {
            item.value = this.detail[item['ename']]
          })
        }
        this.loading = false
      })
    },
    adUserAdLists () {
      let filters = this.userAdFilters
      let params = {
        uid: this.detail.uid,
        p: filters.p,
        l: filters.l
      }

      console.log(params)
      adUserAdLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.userAdList = data.d.lists
          this.userAdFilters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      })
    },
    getAdLists () {
      let params = {
        market: 3,
        l: 500,
        p: 1
      }
      adLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.adLists = data.d.lists.map((item, index) => {
            return {
              title: item.title,
              adid: item.adid
            }
          })
          this.adLists.unshift({
            title: '所有',
            adid: ''
          })
        }
      })
    },
    handleOrderSizeChange (val) {
      this.checkFilters.l = val
      this.adOrderLists()
    },
    handleOrderCurrentChange (val) {
      this.checkFilters.p = val
      this.adOrderLists()
    },
    adOrderLists () {
      let filters = this.checkFilters
      let params = {
        uid: this.detail.uid,
        p: filters.p,
        l: filters.l
      }
      if (filters.adid !== '') {
        params.adid = filters.adid
      }
      if (filters.status !== '') {
        params.status = filters.status
      }
      this.listLoading = true
      adOrderLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.orderList = data.d.lists
          this.checkFilters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.notifyError('服务器出错了')
      })
    },
    preview (index) {
      this.previewDialog = true
      this.previewList = this.orderList[index].screenshot
    }
  },
  mounted () {
    this.detail.uid = parseInt(this.$route.query.uid || 0)
    if (this.detail.uid) {
      this.adUserDetail()
      this.getAdLists()
      this.adUserAdLists()
      this.adOrderLists()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../style/color";
  .dataForm{
    border: 1px solid #e5e5e5;
    padding: 10px;
    border-radius: 10px;
    &__name{
      color: $blue;
      font-weight: bold;
    }
  }
  .base{
    &__container{
      display: flex;
      flex-wrap: wrap;
    }
    &__item{
      width: calc((100% - 20px * 3) / 4);
      text-align: center;
      box-sizing: border-box;
      border: 1px solid #e5e5e5;
      padding: 15px 0;
      border-radius: 10px;
      margin: 0 20px 20px 0;
      &:nth-of-type(4n){
        margin-right: 0;
      }
    }
    &__value{
      font-size: 24px;
      font-weight: 700;
      margin-top: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/module/ad/adUserDetail.vue